import {
  restaurantCategorySchema,
  type ListResult,
  type PaginationParams,
  type RestaurantCategory,
} from '../model';
import { getList, type RequestOptions } from './http';

// Restaurant Category Service — platform-wide restaurant rubrics.

export type ListRestaurantCategoriesParams = PaginationParams;

export const restaurantCategoryApi = {
  /** List all restaurant rubrics — `GET /merchant/restaurant-categories`. */
  list(
    params?: ListRestaurantCategoriesParams,
    options?: RequestOptions,
  ): Promise<ListResult<RestaurantCategory>> {
    return getList(
      'merchant/restaurant-categories',
      restaurantCategorySchema,
      params,
      options,
    );
  },
};
